import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getThemeConfig } from '../externals';
import { useTooltipBehavior } from '../shared';
import { TooltipWrapper, TooltipPane, TooltipPointerSpace, TooltipTitle } from '../styles';

var LargeTooltip = function LargeTooltip(_ref) {
  var children = _ref.children,
      targetElement = _ref.targetElement,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottomRight' : _ref$position,
      title = _ref.title,
      className = _ref.className,
      open = _ref.open,
      dataTest = _ref['data-test'],
      theme = _ref.theme,
      onTooltipShown = _ref.onTooltipShown;

  var _useTooltipBehavior = useTooltipBehavior(targetElement, open, onTooltipShown),
      isTooltipShown = _useTooltipBehavior.isTooltipShown,
      onMouseLeaveWrapper = _useTooltipBehavior.onMouseLeaveWrapper,
      extendedTargetElement = _useTooltipBehavior.extendedTargetElement,
      wrapperRef = _useTooltipBehavior.wrapperRef;

  var componentTheme = useComponentTheme({
    name: 'Tooltip',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(TooltipWrapper, {
    onMouseLeave: onMouseLeaveWrapper,
    className: className,
    ref: wrapperRef,
    "data-test": dataTest ? "".concat(dataTest, "-wrapper") : undefined
  }, extendedTargetElement, /*#__PURE__*/React.createElement(TooltipPane, {
    isShown: isTooltipShown,
    position: position,
    role: "tooltip",
    "data-test": dataTest ? dataTest : undefined,
    customTheme: componentTheme
  }, /*#__PURE__*/React.createElement(TooltipTitle, {
    customTheme: componentTheme
  }, title), /*#__PURE__*/React.createElement("span", null, children), /*#__PURE__*/React.createElement(TooltipPointerSpace, {
    position: position
  })));
};

export default LargeTooltip;